<template>
    <div :class="['form-group', size, disactive == true ? 'd-none' : '']">
        <span v-if="tooltip" data-bs-toggle="tooltip" data-bs-placement="top" :title="tooltip"><font-awesome-icon icon="question-circle"/> </span>
        <label :for="name">{{ label }}</label>
        <textarea v-bind:class="'form-control ' + (errors !== null ? 'error-input' : '')" :name="name" :value="modelValue" :placeholder="placeholder" @input="updateValue($event.target.value)" :rows="rows"></textarea>
        <div class="error" v-if="errors">
            <ul>
                <li v-for="error in errors" :key="error">{{ error }}</li>
            </ul>
        </div>
        <small class="form-text text-muted" v-if="extraInfo" v-html="extraInfo"></small>
    </div>
</template>

<script>
export default {
    props: ['label', 'rows', 'name', 'placeholder', 'size', 'disactive', 'errorMessages', 'extraInfo', 'modelValue', 'tooltip'],

    methods: {
        updateValue(value) {
            this.$emit('input', value);
            if(this.errorMessages && this.name in this.errorMessages) {
                this.value = value;
            }
        }
    },
    data() {
        return {
            value: ''
        };
    },
    computed: {
        errors: function () {
            if(this.errorMessages && this.name in this.errorMessages && this.value === '') {
                return this.errorMessages[this.name];
            }

            return null;
        }
    },
    watch: {
        errorMessages: function(newValue, oldValue) {
            this.value = '';
        }
    }
}
</script>
